import { APIFetchError } from "@cur8/api-client";

/** RFC 7807 problem response returned by the backend on 4XX. */
export type ProblemDetails = {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  traceId?: string;
};

/**
 * Read the server's reason out of a 4XX response, if it carries one.
 * Returns undefined for non-4XX, non-JSON, or bodies without a `detail`.
 */
export async function getProblemDetail(error: unknown) {
  if (!(error instanceof APIFetchError)) {
    return undefined;
  }

  const { response } = error;

  if (response.status < 400 || response.status > 499) {
    return undefined;
  }

  if (!response.headers.get("content-type")?.includes("json")) {
    return undefined;
  }

  try {
    // clone: APIContext.reportError holds the same Response, body can only be read once
    const problem: ProblemDetails = await response.clone().json();
    return problem?.detail?.trim() || undefined;
  } catch {
    return undefined;
  }
}
